import { render, staticRenderFns } from "./JadwalPelatihanList.vue?vue&type=template&id=4cf5355b"
import script from "./JadwalPelatihanList.vue?vue&type=script&lang=js"
export * from "./JadwalPelatihanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports